/**
 * Tiny Zustand store for the command palette open/close state.
 * Kept separate so SaasSidebar and CommandPalette can both import
 * without creating a circular dependency.
 */
import { create } from 'zustand'

interface CommandPaletteState {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}))

/** Convenience imperative opener — usable outside React components (e.g. sidebar chip onClick) */
export function openCommandPalette() {
  useCommandPaletteStore.getState().setOpen(true)
}
